// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/code.js';

import { paths } from '../generated/code';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('code', Original, paths);
